import Vue from "vue";
import VueRouter from "vue-router";
import Layouts from "../layouts";

Vue.use(VueRouter);

/**
 *  path: "/login",   ------页面地址
 meta: {
      title: "登录",    ------页面标题
      icon: "el-icon-user-solid",  ------菜单图标
      oneself: true,  ------是否在单独页面打开
      hide: true,  ------是否隐藏改菜单
    },
 component: () => import("../views/login/index.vue"),  ------组件地址
 */

const routes = [
    {
        path: "/",
        redirect: "/home",
        component: Layouts,
        children: [
            {
                path: "/login",
                name: "Login",
                meta: {
                    title: "登录",
                    oneself: true,
                    hide: true,
                },
                component: () => import("../views/login"),
            },
            {
                path: "/home",
                meta: {title: "首页", icon: "el-icon-s-home"},
                component: () => import("../views/home"),
            },
            {
                path: "/member",
                meta: {title: "会员管理", icon: "el-icon-s-custom"},
                component: () => import("../views/member"),
            },
            {
                path: "/gift",
                meta: {title: "礼品管理", icon: "el-icon-s-goods"},
                component: () => import("../views/gift"),
            },
            {
                path: "/points",
                meta: {title: "积分管理", icon: "el-icon-s-grid"},
                component: () => import("../views/points"),
            },
            {
                path: "/forms",
                meta: {title: "统计报表", icon: "el-icon-s-data"},
                component: () => import("../views/forms"),
                // children: [
                //     {
                //       path: '/dayForms',
                //       name: "DayForms",
                //       meta: {title: "日报表", icon: "el-icon-s-data"},
                //       component: () => import("../views/forms/dayForms"),
                //     },
                //     {
                //       path: '/monthForms',
                //       name: "MonthForms",
                //       meta: {title: "月报表", icon: "el-icon-s-data"},
                //       component: () => import("../views/forms/monthForms"),
                //     }
                //   ]
            },
            {
                path: "/comment",
                meta: {title: "评论建议", icon: "el-icon-s-comment"},
                component: () => import("../views/comment"),
            },
            {
                path: "/dashboard",
                meta: {title: "经营看板", icon: "el-icon-s-platform"},
                component: () => import("../views/dashboard"),
            },
        ],
    },
];

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法，取消路由重复的报错
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// 前置路由拦截器
router.beforeEach((to, from, next) => {
    // 设置当前页签名称
    document.title = to.meta.title;
    // 没有登录并且要去的页面不是登录页面，在强制跳转到登录
    if (to.path === "/login") {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        next()
    } else if (!localStorage.getItem('userInfo')) {
        next('/login')
    } else {
        next()
    }
});

export default router;
